<template>
  <VAutocomplete
    v-model="selectedAnalyses"
    :items="displayAnalysis"
    multiple
    outlined
    @change="UpdateData"
  />
</template>
<script>
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete';
import { mapGetters } from 'vuex';


export default ({
    components: {
        VAutocomplete,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
        controlChart: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            analyses: [],
            selectedAnalyses: [],
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
        ]),
        displayAnalysis() {
            return this.analyses.map(analysis => ({
                name: analysis.analysisType.name[this.userLang] || analysis.analysisType.name[this.teamMainLang],
                id: analysis.analysisType.id,
            }));
        },
    },
    async created() {
        const { data } = await this.$rq.getComponentConfigurations(this.node.ref, { includeDevices: false });
        const configurations = data.configurations.filter(configuration => configuration.active);
        this.analyses = configurations;
        if (!this.analyses.length) return;
        this.setSelectedAnalyses();
    },

    methods: {
        setSelectedAnalyses() {
            const selectedAnalysisTypeIds = this.controlChart?.charts?.map(chart => chart?.analysisType?.id).filter(Boolean);
            const selectedAnalysis = selectedAnalysisTypeIds?.map(id => this.analyses.find(an => an.analysisType.id === id));
            this.$store.commit('setChartControleAnalyses', selectedAnalysis.filter(Boolean) || []);
            this.selectedAnalyses = selectedAnalysisTypeIds;
        },
        UpdateData(analysesIds) {
            const analyses = analysesIds.map(id => this.analyses?.find(an => an.analysisType.id === id));
            this.$store.commit('setChartControleAnalyses', analyses.filter(Boolean) || []);
        },

    },
});
</script>
